import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=d3744bb2&scoped=true"
import script from "./Areas.vue?vue&type=script&lang=ts"
export * from "./Areas.vue?vue&type=script&lang=ts"
import style0 from "./Areas.vue?vue&type=style&index=0&id=d3744bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3744bb2",
  null
  
)

export default component.exports